import { useCallback, useEffect, useState } from 'react';

import { type FlowListName } from '@/components/Wizard';

const UNTRACEABLE_FLOWLISTS: FlowListName[] = ['loading', 'error'];

export const useFlowlistHistory = (currentFlowlist: FlowListName) => {
  const [flowlistHistory, setFlowlistHistory] = useState<Set<FlowListName>>(new Set());

  const addToHistory = useCallback((name: FlowListName) => {
    if (UNTRACEABLE_FLOWLISTS.includes(name)) {
      return;
    }

    setFlowlistHistory(prev => {
      const next = new Set(prev);
      next.add(name);
      return next;
    });
  }, []);

  const removeFromHistory = useCallback((name: FlowListName) => {
    setFlowlistHistory(prev => {
      const next = new Set(prev);
      next.delete(name);
      return next;
    });
  }, []);

  useEffect(() => {
    addToHistory(currentFlowlist);
  }, [currentFlowlist, addToHistory]);

  return { flowlistHistory, removeFromHistory };
};
